/* eslint-disable no-console */
import PropTypes from 'prop-types';
import React, { useState } from 'react';
import { Table, Icon, Button, Popconfirm, message } from 'antd';
import moment from 'moment';
import { withTranslation } from 'react-i18next';

import { LoadingIcon } from '../../../components/loading';
import BatchRepo from '../../../repository/batch';
import money from '../../../helpers/money';

const DebitsList = (props) => {
  const { business, account, t } = props;
  const [downloading, setDownloading] = useState(false);

  const handleDownloadClick = async (event, batch) => {
    event.preventDefault();
    setDownloading(true);
    try {
      await BatchRepo.downloadDebitsFile(business, account, batch._id); // eslint-disable-line no-underscore-dangle
    } catch (error) {
      console.error('ERROR: handleDownloadClick() response: ', error.response);
      message.error(`${t('error.downloading_batch')}: ${error.response.data.message}`);
    }
    setDownloading(false);
  };

  const handleCancelClick = async (event, batch) => {
    event.preventDefault();
    try {
      await BatchRepo.cancelBatch(business, account, batch._id); // eslint-disable-line no-underscore-dangle
    } catch (error) {
      console.error('ERROR: handleCancelClick() response: ', error.response);
      message.error(`${t('error.canceling_batch')}: ${error.response.data.message}`);
    }
  };

  const columns = [
    {
      title: t('description'),
      dataIndex: 'description',
    },
    {
      title: t('amount'),
      dataIndex: 'total_amount',
      render: (amount) => ((amount) ? money.toDisplay(Number.parseInt(amount.v, 10), amount.c, true) : ''),
    },
    {
      title: t('item_count'),
      dataIndex: 'item_count',
    },
    {
      title: t('status'),
      dataIndex: 'status',
      width: 150,
      render: (value) => t(`debit.status.${(value)}`),
    },
    {
      title: t('created_at'),
      dataIndex: 'created_at',
      width: 200,
      render: (created_at) => ((created_at) ? moment(created_at).format('lll') : ''),
      sorter: (a, b) => moment(a.created_at) - moment(b.created_at),
      sortDirections: ['descend', 'ascend'],
      defaultSortOrder: 'descend',
    },
    {
      title: '',
      width: 65,
      render: (text, batch) => (
        <Button type="button" disabled={downloading} onClick={(event) => handleDownloadClick(event, batch)}>
          <Icon type="cloud-download" />
        </Button>
      ),
    },
    {
      title: '',
      width: 65,
      render: (text, batch) => (
        <Popconfirm title={t('batch.cancel_popconfirm')} onConfirm={(event) => handleCancelClick(event, batch)} okText="Yes" cancelText="No">
          <Button type="button">
            <Icon type="stop" />
          </Button>
        </Popconfirm>
      ),
    },
  ];

  return (
    <Table
      dataSource={props.debits || []}
      columns={columns}
      {...props}
      loading={{
        indicator: LoadingIcon,
        size: 'large',
        spinning: props.loading || false,
      }}
      bordered={false}
      rowKey={(row, index) => index}
      scroll={{ x: true }}
    />
  );
};

DebitsList.propTypes = {
  debits: PropTypes.array,
  loading: PropTypes.bool,
  account: PropTypes.object,
  business: PropTypes.object,
  t: PropTypes.func,
};

export default withTranslation()(DebitsList);
